import objTealium from '../utils/Tealium/Tealium';
import {
  businessCashAdvanceApprovedRoute,
  businessCashAdvanceCalculationRoute,
  businessCashAdvanceDashboardRoute,
  businessCashAdvanceDigitalTermsRoute,
  businessCashAdvanceNoQualifyRoute,
  businessCashAdvancePreApprovedRoute,
  businessCashAdvanceRoute,
  documentsRoute,
  firstTimeLoginOtpRoute,
  merchantLoginRoute,
  merchantProfileRoute,
  paymentsDashboardRoute,
  resetPasswordMerchantIdRoute,
  resetPasswordOtpRoute,
  resetPasswordResendOtpRoute,
  setPasswordRoute,
  terminalsRoute,
  terminalTransactionsRoute,
  transactionsRoute,
  vodapayDealsRoute,
} from '../routing/routes';
const merchantIdHashKey = 'smme_portal.merchant_id.hashed';
const onboardingMerchantIdHashKey = 'onboarding.merchant.id.hashed';
const subscriptionTypeKey = 'smme_portal.subscription_type';
const loginMethodKey = 'smme_portal.login_method';
const resetJourneyKey = 'smme_portal.reset_journey';

const customerTypeMap = {
  dealer: 'Affiliate agent',
  agent: 'Store agent',
  normal: 'Consumer',
  pos: 'POS Distribution',
};

const journeyMap = {
  ss: 'self service',
  ob: 'on boarding',
};

const pageNameMap = {
  start: 'vodapay: smme: merchant onboarding: get started',
  'agent-login': 'vodapay: smme: merchant onboarding: agent login',
  'business-type': 'vodapay: smme: merchant onboarding:type of business',
  'choose-solution': 'vodapay: smme: merchant onboarding: add devices: online',
  'your-business': 'vodapay: smme merchant onboarding: business information',
  'your-business-address': 'vodapay: smme: merchant onboarding: business address',
  'your-business-ids': 'vodapay:smme: merchant onboarding: director information',
  'your-details': 'vodapay:smme: merchant onboarding: your details',
  'your-details-address': 'vodapay: smme: merchant onboarding: residential address',
  'more-details': 'vodapay: smme: merchant onboarding: your details 2',
  'your-details-selfie': 'vodapay:smme: merchant onboarding: selfie options',
  'your-details-banking-details': 'vodapay:smme: merchant onboarding: banking details',
  'upload-documents': 'vodapay:smme: merchant onboarding: document upload',
  confirm: 'vodapay:smme: merchant onboarding: order summary',
  'thank-you': 'vodapay:smme: merchant onboarding: application complete',
  reference: 'vodapay: smme: merchant onboarding:continue application',
  otp: 'vodapay: smme: merchant onboarding:enter OTP',
};

const routeToPageNameMap = {
  [merchantLoginRoute]: 'login',
  [resetPasswordMerchantIdRoute]: 'forgot password',
  [resetPasswordOtpRoute]: 'login OTP',
  [resetPasswordResendOtpRoute]: 'login resend OTP',
  [setPasswordRoute]: 'create password',
  [firstTimeLoginOtpRoute]: 'forgot password',
  [paymentsDashboardRoute]: 'dashboard',
  [merchantProfileRoute]: 'my profile',
  [terminalsRoute]: 'terminals',
  [transactionsRoute]: 'account transactions',
  [terminalTransactionsRoute]: 'terminal transactions',
  [documentsRoute]: 'my documents',
  [businessCashAdvanceRoute]: 'get financed',
  [businessCashAdvanceDashboardRoute]: 'bca dashboard',
  [businessCashAdvanceNoQualifyRoute]: 'bca info negative',
  [businessCashAdvancePreApprovedRoute]: 'bca info',
  [businessCashAdvanceCalculationRoute]: 'bca apply now',
  [businessCashAdvanceDigitalTermsRoute]: 'view terms and conditions',
  [businessCashAdvanceApprovedRoute]: 'approved',
  [vodapayDealsRoute]: 'vodapay deals',
};

const attempt = (func) => {
  try {
    func();
  } catch (err) {
    console.error(err);
    // intentional swallowing of non functional error
  }
};
let merchantId = 'unset';
let subscriptionType = 'unset';
let loginMethod = 'unset';
let resetJourney = 'change login password';
let onboardingCustomerType = 'normal';

export const SetTealiumMerchantDetails = (id, type) => {
  //hash merchant id
  var hash = 0,
    i,
    chr;
  for (i = 0; i < id.length; i++) {
    chr = id.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  merchantId = hash;
  subscriptionType = type;

  sessionStorage.setItem(merchantIdHashKey, merchantId);
  sessionStorage.setItem(subscriptionTypeKey, subscriptionType);
};

export const HashId = (id) => {
  //hash merchant id
  var hash = 0,
    i,
    chr;
  for (i = 0; i < id.length; i++) {
    chr = id.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  merchantId = hash;

  sessionStorage.setItem(onboardingMerchantIdHashKey, merchantId);
  return merchantId;
};

export const UnsetTealiumMerchantDetails = () => {
  merchantId = 'unset';
  subscriptionType = 'unset';
  sessionStorage.setItem(merchantIdHashKey, merchantId);
  sessionStorage.setItem(subscriptionTypeKey, subscriptionType);
};

export const SetLoginType = (loginType) => {
  loginMethod = loginType;
  sessionStorage.setItem(loginMethodKey, loginMethod);
};
export const UnsetLoginType = () => {
  loginMethod = 'unset';
  sessionStorage.setItem(loginMethodKey, loginMethod);
};

export const SetResetJourney = (journey) => {
  resetJourney = journey;
  sessionStorage.setItem(resetJourneyKey, resetJourney);
};
export const UnsetResetJourney = () => {
  resetJourney = 'change login password';
  sessionStorage.setItem(resetJourneyKey, resetJourney);
};

const getSubscriptionType = () => {
  return subscriptionType === 'unset'
    ? sessionStorage.getItem(subscriptionTypeKey)
    : subscriptionType;
};

const getLowestLevelPath = () => {
  const url = window.location.href;
  const urlSplit = url.split('/');
  return urlSplit[urlSplit.length - 1];
};

export const setOnboardingCustomerType = (customerType) => {
  onboardingCustomerType = customerType;
};

const getPageName = () => {
  const pagePath = window.location.pathname;
  const pageHash = window.location.hash.substring(1);
  const urlSplit = window.location.href.split('/');
  const lowestLevelPath = urlSplit[urlSplit.length - 1];
  return (
    routeToPageNameMap[pagePath] ||
    routeToPageNameMap[pageHash] ||
    pageNameMap[lowestLevelPath] ||
    'unknown'
  );
};

const emitPageError = (errorName, pageName, linkName, errorCode, errorType, journey) => {
  attempt(() =>
    objTealium.link({
      event_name: 'page_error',
      link_name: linkName,
      page_error_name: errorName,
      page_error_code: errorCode,
      page_error_type: errorType,
      page_name: pageName,
      ...(journey === journeyMap.ss ? staticSelfServicePageDetails() : staticOnboardingPageDetails),
    }),
  );
};

const emitFormError = (errorName, pageName, linkName, errorCode, errorType, journey) => {
  attempt(() =>
    objTealium.link({
      event_name: 'form_error',
      form_error_name: errorName,
      form_error_code: errorCode,
      form_error_type: errorType,
      page_name: pageName,
      link_name: linkName,
      ...(journey === journeyMap.ss ? staticSelfServicePageDetails() : staticOnboardingPageDetails),
    }),
  );
};

const emitEventError = (errorName, pageName, linkName, errorCode, errorType, journey) => {
  attempt(() =>
    objTealium.link({
      event_name: 'event_error',
      link_name: linkName,
      event_error_name: errorName,
      event_error_code: errorCode,
      event_error_type: errorType,
      page_name: pageName,
      ...(journey === journeyMap.ss ? staticSelfServicePageDetails() : staticOnboardingPageDetails),
    }),
  );
};

const staticOnboardingPageDetails = () => ({
  page_url: window.location.href,
  page_section: 'onboarding',
  page_channel: 'vodapay: merchant onboarding',
  page_subdomain: 'merchant onboarding',
});

const staticSelfServicePageDetails = () => ({
  page_url: window.location.href,
  page_section: 'self service',
  page_channel: 'vodapay: self service',
  page_subdomain: 'vodapay: self service',
});

const staticToPVariables = () => ({
  page_url: window.location.href,
  page_section: 'tap on phone onboarding',
  page_channel: 'tap on phone app',
  page_subdomain: 'merchant onboarding',
  page_type: 'webview',
});

const TealiumEvents = {
  // New style
  loginPageLoadNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view, form_start, visitor_login_start',
        page_name: 'vodapay: smme: self service: login',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        form_name: 'self service login',
        form_type: 'login',
      }),
    );
  },
  loginClickBackToVodacomBusiness: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: back to vodacombusiness.co.za',
        page_name: 'vodapay: smme: self service: login',
        link_type: 'e',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  loginClickFirstTimeMember: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: first time member link',
        page_name: 'vodapay: smme: self service: login',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  loginClickForgotPassword: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: forgot password',
        page_name: 'vodapay: smme: self service: login',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  loginClickLogin: (merchantId) => {
    attempt(() =>
      objTealium.link({
        event_name: 'form_end, visitor_login_complete',
        event_action: 'click',
        link_name: 'vodapay: smme portal: login',
        page_name: 'vodapay: smme: self service: login',
        link_type: 'o',
        link_url: window.location.href,
        form_name: 'self service login',
        visitor_id_user: merchantId,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // Login forgot password
  loginForgotPasswordPageLoadNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: forgot password',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  loginForgotPasswordClickReset: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: forgot password reset',
        page_name: 'vodapay: smme: self service: forgot password',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // Login OTP
  loginOTPPageLoadNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: login OTP',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  loginOTPClickResend: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: click resend OTP',
        page_name: 'vodapay: smme: self service: login OTP',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  loginOTPClickContinue: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, visitor_login_multi_factor',
        event_action: 'click',
        link_name: 'vodapay: smme portal: click OTP continue',
        page_name: 'vodapay: smme: self service: login OTP',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // Resend OTP
  loginResendOTPPageLoadNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: login resend OTP',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  loginResendOTPClickResend: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: click resend OTP',
        page_name: 'vodapay: smme: self service: login resend OTP',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // Set password
  loginSetPasswordPageLoadNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: create password',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  loginSetPasswordClickSetPassword: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: click set password',
        page_name: 'vodapay: smme: self service: create password',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  //Logout
  logout: () => {
    UnsetLoginType();
    attempt(() =>
      objTealium.link({
        event_name: 'visitor_logout',
        link_name: 'vodapay: smme: logout',
        page_name: `vodapay: smme: self service: ${getPageName()}`,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // New style
  // Page load
  dashboardPageLoadedNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: dashboard',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  dashboardDateFilterApplied: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'page_filter, tool_start',
        link_name: 'vodapay: smme portal: date filter applied',
        page_name: 'vodapay: smme: self service: dashboard',
        page_filters_type: 'date',
        tool_name: 'vodapay: smme portal: date filter',
        tool_type: 'select',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  dashboardTerminalFiltersApplied: (filterType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'page_filter, tool_start',
        link_name: 'vodapay: smme portal: terminal filter applied',
        page_name: 'vodapay: smme: self service: terminals',
        page_filters_type: 'terminal',
        page_filters_value: filterType,
        tool_name: 'vodapay: smme portal: terminal filter',
        tool_type: 'select',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  dashboardBCAQualifiesToastAppears: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'smme_bca_qualify',
        link_name: 'vodapay: smme portal: bca qualify',
        page_name: 'vodapay: smme: self service: dashboard',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  dashboardApplyNowClicked: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: bca apply now',
        page_name: 'vodapay: smme: self service: dashboard',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  //Terminals
  // New style
  terminalsPageLoadNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: terminals',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  terminalsFiltersApplied: (filterValue) => {
    attempt(() =>
      objTealium.link({
        event_name: 'page_filter, tool_start',
        link_name: 'vodapay: smme portal: terminal filter applied',
        page_name: 'vodapay: smme: self service: terminals',
        page_filters_type: 'terminal',
        page_filters_value: filterValue,
        tool_type: 'select',
        tool_name: 'terminals filter',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  terminalsLoadMoreClicked: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        link_name: 'vodapay: smme portal: terminals view more',
        page_name: 'vodapay: smme: self service: terminals',
        tool_name: 'terminals show more',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  //Terminal Transactions
  terminalTransactionPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: terminal transactions',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  // New style
  terminalTransactionsPageLoadNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: terminal transactions',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  terminalTransactionsDateFilterApplied: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'page_filter, tool_start',
        link_name: 'vodapay: smme portal: date filter applied',
        page_name: 'vodapay: smme: self service: terminal transactions',
        page_filters_type: 'date',
        tool_name: 'vodapay: smme portal: date filter',
        tool_type: 'select',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  transactionsTimeFilter: (isFrom, value) => {
    attempt(() =>
      objTealium.link({
        event_name: 'page_filter, tool_start, ui_interaction',
        link_name: `vodapay: smme portal: time ${isFrom ? 'start' : 'end'} filter applied`,
        page_name: getPageName(),
        page_filters_type: 'transaction type',
        page_filters_value: value,
        tool_name: `vodapay: smme portal: time ${isFrom ? 'start' : 'end'} filter`,
        tool_type: 'select',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  terminalTransactionsTransactionFilterApplied: (filterValue) => {
    attempt(() =>
      objTealium.link({
        event_name: 'page_filter, tool_start',
        link_name: 'vodapay: smme portal: transaction type filter applied',
        page_name: 'vodapay: smme: self service: terminal transactions',
        page_filters_type: 'transaction type',
        page_filters_value: filterValue,
        tool_name: 'vodapay: smme portal: transaction type filter',
        tool_type: 'select',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  terminalTransactionsExportClicked: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: export transactions',
        page_name: 'vodapay: smme: self service: terminal transactions',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  terminalTransactionsSearchByAmount: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, search_apply',
        event_action: 'click',
        link_name: 'vodapay: smme portal: search by amount',
        page_name: 'vodapay: smme: self service: terminal transactions',
        link_type: 'o',
        search_category: 'transaction amount',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  terminalTransactionsSearchByReference: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, search_apply',
        event_action: 'click',
        link_name: 'vodapay: smme portal: search by reference',
        page_name: 'vodapay: smme: self service: terminal transactions',
        link_type: 'o',
        search_category: 'transaction reference',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  terminalTransactionsClickLoadMore: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        link_name: 'vodapay: smme portal: transactions load more',
        page_name: 'vodapay: smme: self service: terminal transactions',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  terminalTransactionsClickMoreTransactionInformation: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        link_name: 'vodapay: smme portal: transactions view individual',
        page_name: 'vodapay: smme: self service: terminal transactions',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // Transactions
  // Account transactions
  accountTransactionsPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: account transactions',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  accountTransactionsDateFilterApplied: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'page_filter, tool_start',
        link_name: 'vodapay: smme portal: date filter applied',
        page_name: 'vodapay: smme: self service: account transactions',
        page_filters_type: 'date',
        tool_name: 'vodapay: smme portal: date filter',
        tool_type: 'select',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  accountTransactionsTransactionFilterApplied: (filterValue) => {
    attempt(() =>
      objTealium.link({
        event_name: 'page_filter, tool_start',
        link_name: 'vodapay: smme portal: transaction type filter applied',
        page_name: 'vodapay: smme: self service: account transactions',
        page_filters_type: 'transcation type',
        page_filters_value: filterValue,
        tool_name: 'vodapay: smme portal: transaction type filter applied',
        tool_type: 'select',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  accountTransactionsExportClicked: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: export transactions',
        page_name: 'vodapay: smme: self service: account transactions',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  accountTransactionsSearchByAmount: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, search_apply',
        event_action: 'click',
        link_name: 'vodapay: smme portal: search by amount',
        page_name: 'vodapay: smme: self service: account transactions',
        link_type: 'o',
        search_category: 'transaction amount',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  accountTransactionsSearchByReference: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, search_apply',
        event_action: 'click',
        link_name: 'vodapay: smme portal: search by reference',
        page_name: 'vodapay: smme: self service: account transactions',
        link_type: 'o',
        search_category: 'transaction reference',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  accountTransactionsClickViewMoreTransactions: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: transactions show more',
        page_name: 'vodapay: smme: self service: account transactions',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  accountTransactionsClickViewIndividualTransaction: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: transactions view individual',
        page_name: 'vodapay: smme: self service: account transactions',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  //Refunds
  transactionRefundsPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_url: window.location.href,
        page_name: 'vodapay: smme: self service: transaction refunds',
        page_channel: 'vodapay: self service',
        page_section: 'self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },

  goToRefundsPage: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: refund customer',
        page_name: 'vodapay: smme: self service: account transactions',
        link_type: 'o',
        link_url: window.location.href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  backToTransactions: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: back to transactions',
        page_name: 'vodapay: smme: self service: transaction refunds',
        link_type: 'o',
        link_url: window.location.href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  clickViewRefunds: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: refund transaction',
        page_name: 'vodapay: smme: self service: transaction refunds',
        link_type: 'o',
        link_url: window.location.href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  viewRefundsModal: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view, journey_start, form_start',
        page_url: window.location.href,
        page_name: 'vodapay: smme: self service: transaction refunds',
        page_channel: 'vodapay: self service',
        page_section: 'self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        form_name: 'refund customer',
        journey_name: 'refund customer',
        journey_type: 'transaction',
      }),
    );
  },

  performRefund: (value) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, form_end',
        event_action: 'click',
        link_name: 'vodapay: smme portal: refund transaction',
        page_name: 'vodapay: smme: self service: transaction refunds',
        link_type: 'o',
        link_url: window.location.href,
        form_name: 'refund customer',
        transaction_total: value,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  closeRefundsModalNormal: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, journey_end',
        event_action: 'click',
        link_name: 'vodapay: smme portal:  refund transaction',
        page_name: 'vodapay: smme: self service: transaction refunds',
        link_type: 'o',
        link_url: window.location.href,
        journey_name: 'refund customer',
        journey_type: 'transaction',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  closeRefundsModalFailure: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, journey_end',
        event_action: 'click',
        link_name: 'vodapay: smme portal: close refund transaction',
        page_name: 'vodapay: smme: self service: transaction refund failed',
        link_type: 'o',
        link_url: window.location.href,
        journey_name: 'refund customer',
        journey_type: 'transaction',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  successfulRefund: (total) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view, journey_end, smme_refund_processed',
        page_url: window.location.href,
        page_name: 'vodapay: smme: self service: transaction refunds',
        page_channel: 'vodapay: self service',
        page_section: 'self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        journey_name: 'refund customer',
        journey_type: 'transaction',
        transaction_total: total,
      }),
    );
  },

  refundFailedModalLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_url: window.location.href,
        page_name: 'vodapay: smme: self service: transaction refund failed',
        page_channel: 'vodapay: self service',
        page_section: 'self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },

  refundFailedRetry: (total) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: retry refund transaction',
        page_name: 'vodapay: smme: self service: transaction refund failed',
        link_type: 'o',
        transaction_total: total,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  refundError: (errorMessage) => {
    attempt(() =>
      objTealium.link({
        event_name: 'event_error',
        event_error_name: 'Refund error',
        event_error_code: errorMessage,
        event_error_type: 'traderoot error',
        link_name: 'vodapay: smme portal: transaction refund error',
        page_name: 'vodapay: smme: self service: transaction refunds',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  refundExportClicked: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: export transactions',
        page_name: 'vodapay: smme: self service: transaction refunds',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  //Merchant profile
  merchantProfilePageLoad: () => {
    attempt(() =>
      objTealium.view({
        service_application_event: 'start, finish',
        visitor_type: 'merchant',
        page_event: 'view',
        service_application_name: 'mysmme portal: dashboard: merchant information (query)',
        service_application_type: 'query',
        visitor_subscription_type: getSubscriptionType(),
        visitor_merchant_id: merchantId,
        page_name: 'mysmme portal: dashboard: merchant information',
        page_channel: 'merchant profile',
      }),
    );
  },
  merchantProfileChangePassword: () => {
    attempt(() =>
      objTealium.view({
        page_form_event: 'started',
        page_form_name: 'mysmme portal: change login password form',
        service_application_event: 'start',
        service_application_name: 'mysmme portal: change login password (transaction)',
        service_application_step: 'mysmme portal: change login password',
        service_application_type: 'transaction',
        page_event: 'view',
        page_name: 'mysmme portal: login: reset password',
        page_channel: 'merchant profile',
      }),
    );
  },

  merchantProfilePageLoadNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: my profile',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  merchantProfileClickChangePassword: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: change password',
        page_name: 'vodapay: smme: self service: my profile',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  merchantProfileChangePasswordClickSetPassword: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: set password',
        page_name: 'vodapay: smme: self service: my profile',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  merchantProfileChangePasswordClickCancel: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: cancel password change',
        page_name: 'vodapay: smme: self service: my profile',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  merchantProfileChangePasswordSuccess: () => {
    attempt(() =>
      objTealium.link({
        link_name: 'vodapay: smme portal: change password successful',
        page_name: 'vodapay: smme: self service: my profile',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // Reset Password
  firstTimeLoginEnter: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,journey_start',
        page_name: 'vodapay: smme: self service: first time user activation',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        journey_name: 'first time user activation',
        journey_type: 'self service',
      }),
    );
  },
  // VodaPay Deals
  vodapayDealsPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: vodapay deals',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  //Document Management
  // TODO: update when reskin spec updated
  documentsView: () => {
    attempt(() =>
      objTealium.link({
        page_tool_event: 'use',
        page_tool_name: 'mysmme portal: dashboard: document management: view',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  myDocumentsPageLoadNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: my documents',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  myDocumentsPageClickDownloadButton: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: download document',
        page_name: 'vodapay: smme: self service: my documents',
        link_type: 'b',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  myDocumentsPageClickLoadMore: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: documents view',
        link_id: 'vodapay: smme portal: documents view',
        page_name: 'vodapay: smme: self service: my documents',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  //////////////////////////// ----- BCA ----- ////////////////////////
  // Get Financed

  getFinancedFundMeMoreInfo: (url) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: bta more info',
        page_name: 'vodapay: smme: self service: get financed',
        link_type: 'o',
        link_url: url,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  getFinancedBCANoQualMoreInfo: (href) => {
    attempt(() =>
      objTealium.link({
        link_type: 'o',
        link_name: 'mysmme portal: finance solutions: business cash advance - more info',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // New style
  getFinancedPageLoadNewStyle: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: get financed',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  getFinancedClickBTAMoreInfo: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: bta more info',
        page_name: 'vodapay: smme: self service: get financed',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  getFinancedClickBTAApplyNow: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: bta apply now',
        page_name: 'vodapay: smme: self service: get financed',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  getFinancedClickBCAMoreInfo: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: bca more info',
        page_name: 'vodapay: smme: self service: get financed',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  getFinancedClickBCAApplyNow: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme portal: bca apply now',
        page_name: 'vodapay: smme: self service: get financed',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // BCA info page
  infoPageBCAPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: bca info',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  infoPageBCAClickFAQ: (topic) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        event_label: topic,
        event_category: 'FAQ selection',
        link_name: 'vodapay: smme: self service: bca faq click',
        page_name: 'vodapay: smme: self service: bca info',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  infoPageBCAClickDisclaimerLink: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: self service: bca discliamer click',
        page_name: 'vodapay: smme: self service: bca info',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  infoPageBCAClickViewOffer: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: self service: bca view offer click',
        page_name: 'vodapay: smme: self service: bca info',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // BCA Apply now
  applyNowBCAPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view, journey_start',
        page_name: 'vodapay: smme: self service: bca apply now',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        journey_name: 'BCA application',
        journey_type: 'transaction',
      }),
    );
  },
  applyNowBCAClickOnDigitalTerms: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: self service: bca click on digital terms',
        page_name: 'vodapay: smme: self service: bca apply now',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  applyNowBCAClickOnPaymentRefactorInfoButton: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: self service: bca payment refactor info',
        page_name: 'vodapay: smme: self service: bca apply now',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  applyNowBCAClickOnGetAdvance: (paymentPeriod, transactionTotal) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: self service: bca get advance',
        page_name: 'vodapay: smme: self service: bca apply now',
        link_type: 'o',
        smme_bca_payment_period: paymentPeriod,
        transaction_total: transactionTotal,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // BCA Business Information
  businessInformationBCAPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view, form_start',
        page_name: 'vodapay: smme: self service: bca business information',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        form_name: 'bca business information',
      }),
    );
  },
  businessInformationBCAClickNext: (businessType, idType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, form_end',
        event_action: 'click',
        link_name: 'vodapay: smme: self service: bca next click',
        page_name: 'vodapay: smme: self service: bca business information',
        link_type: 'o',
        form_name: 'bca business information',
        product_target_segment: businessType,
        visitor_id_asset_primary: idType,
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // BCA Confirm T&Cs
  confirmTCsBCAPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: confirm terms and conditions',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  confirmTCsBCAClickTCs: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: self service: bca terms click',
        page_name: 'vodapay: smme: self service: confirm terms and conditions',
        link_type: 'o',
        link_url: href,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  confirmTCsBCAClickConfirm: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: self service: bca confirm click',
        page_name: 'vodapay: smme: self service: confirm terms and conditions',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  bcaSuccessful: (fundingAmount, totalRepaymentAmount, repaymentTerm, transactionId) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,journey_end,smme_application_complete,transaction_complete',
        page_name: 'vodapay: smme: self service: BCA application success',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        journey_name: 'BCA application',
        journey_type: 'transaction',
        product_name: 'BCA',
        product_quantity: 1,
        product_price: fundingAmount,
        product_category: 'BCA',
        transaction_total: totalRepaymentAmount,
        transaction_id: transactionId,
        transaction_payment_type: 'monthly',
        smme_bca_payment_period: repaymentTerm,
      }),
    );
  },
  // View  T&Cs
  viewTCsBCAPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: bca view contract',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  viewTCsBCAClickPrint: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: self service: bca print contract',
        page_name: 'vodapay: smme: self service: bca view contract',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  viewTCsBCAClickDownload: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: self service: bca download contract',
        page_name: 'vodapay: smme: self service: bca view contract',
        link_type: 'b',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  // BCA Dasboard
  dashboardBCAPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: bca dashboard',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      }),
    );
  },
  dashboardBCAClickFAQ: (topic) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        event_label: topic,
        event_category: 'FAQ selection',
        link_name: 'vodapay: smme: self service: bca dsaboard faq click',
        page_name: 'vodapay: smme: self service: bca dashboard',
        link_type: 'o',
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  // Calculation (offers)
  // Success
  onBCASuccess: (amount, refNumber) => {
    attempt(() =>
      objTealium.view({
        service_application_event: 'finish',
        service_application_step:
          'mysmme portal: finance solutions: business cash advance: success',
        page_event: 'view',
        service_application_name:
          'mysmme portal: finance solutions: business cash advance (transaction)',
        service_application_type: 'transaction',
        page_name: 'mysmme portal: finance solutions: business cash advance: success',
        sales_event: 'business_cash_advance, purchase',
        sales_order_id: refNumber,
        sales_product_category: 'Business Cash Advance',
        sales_product_id: 'Approved Advance Amount',
        sales_product_quantity: '1',
        sales_product_price: amount,
        page_channel: 'bca success',
      }),
    );
  },

  // TODO: update when page added to reskin spec
  onBCANoQualifyLoad: () => {
    attempt(() =>
      objTealium.view({
        service_application_event: 'start, finish',
        visitor_type: 'merchant',
        page_event: 'view',
        service_application_name:
          'mysmme portal: business cash advance: dashboard not qualify (query)',
        service_application_type: 'query',
        service_application_step:
          'mysmme portal: business cash advance: dashboard: not qualify for advance',
        visitor_subscription_type: 'small business',
        visitor_merchant_id: merchantId,
        page_name: 'mysmme portal: business cash advance: dashboard not qualify',
        page_channel: 'bca no qualify',
      }),
    );
  },

  ///////// ----- Merchant onboarding ----- //////
  letsGetStartedPageLoadFormStartCombined: (customerType, assistantId) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_start',
        page_name: 'vodapay: smme: merchant onboarding: get started',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',

        // form start
        form_name: 'get started',
        form_type: 'create application',
        form_step_name: 'first name',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
      }),
    );
  },

  letsGetStartedClickGetStartedAndFormEndCombined: (href, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,visitor_register,form_end',
        event_action: 'click',
        link_name: 'vodapay: smme: get started',
        page_name: 'vodapay: smme: merchant onboarding: get started',
        link_type: 'o',
        link_url: href,
        visitor_customer_type: customerTypeMap[customerType],

        // form_end
        form_name: 'get started',
        form_type: 'create application',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  letsGetStartedClickContinueApplication: (href, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: continue with application',
        page_name: 'vodapay: smme: merchant onboarding: get started',
        link_type: 'o',
        link_url: href,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  letsGetStartedClickBackToVodacom: (href, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: back to vodacombusiness.co.za',
        page_name: 'vodapay: smme: merchant onboarding: get started',
        link_type: 'e',
        link_url: href,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  agentLoginPageLoad: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_start',
        page_name: 'vodapay: smme: merchant onboarding: agent login',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',

        // form start
        form_name: 'agent login',
        form_type: 'login',
        form_step_name: 'agent ID',
        visitor_customer_type: customerTypeMap['agent'],
      }),
    );
  },
  agentLoginPageClickContinueApplication: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: continue with application',
        page_name: 'vodapay: smme: merchant onboarding: agent login',
        link_type: 'o',
        link_url: href,
        visitor_customer_type: 'Store agent',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  notAnAgentEvent: (href, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: sign up as a merchant',
        page_name: 'vodapay: smme: merchant onboarding: agent login',
        link_type: 'e',
        link_url: href,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  agentLoginClickAndFormEndCombined: (href) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,visitor_login_complete,form_end',
        event_action: 'click',
        link_name: 'vodapay: smme:agent login',
        page_name: 'vodapay: smme: merchant onboarding: agent login',
        link_type: 'o',
        link_url: href,
        visitor_customer_type: customerTypeMap['agent'],

        // form end
        form_name: 'agent login',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  businessTypePageLoad: (isOtpUsed, customerType, assistantId) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,journey_start',
        page_name: 'vodapay: smme: merchant onboarding: type of business',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'business type',
        page_type: 'website',

        // journey_start
        journey_name: isOtpUsed ? 'continue application' : 'new application',
        journey_type: 'transaction',

        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
      }),
    );
  },

  businessTypePageNextClick: (businessType, consumerType, buyingMethod, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: next click',
        page_name: 'vodapay: smme: merchant onboarding:type of business',
        link_type: 'o',
        product_target_segment: businessType,
        smme_person_appying: consumerType,
        smme_buying_method: buyingMethod,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  businessTypePageJourneyPhaseCalculateFees: (customerType, assistantId) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_journey_phase: 'calculate fees',
        page_name: 'vodapay: smme: merchant onboarding: calculate fees',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
      }),
    );
  },

  letsCalculateYourFeesClickCalculate: (amount, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        event_value: amount === 0 ? 'yes' : 'no',
        link_name: 'vodapay: smme: calculate fees',
        page_name: 'vodapay: smme: merchant onboarding: calculate fees',
        link_type: 'o',
        link_value: amount,
        smme_monthly_income: amount,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  chooseYourSolutionMiniAppCameraModal: (businessType, customerType) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: `vodapay: smme: merchant onboarding: camera permission`,
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'webview',
        product_target_segment: businessType,
        visitor_customer_type: customerTypeMap[customerType],
      }),
    );
  },

  openCart: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'cart_view, ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: view cart',
        page_name: getPageName(),
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  removeFromCart: (customerType, productName) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, cart_remove',
        event_action: 'click',
        link_name: 'vodapay: smme: remove product from cart',
        page_name: getPageName(),
        visitor_customer_type: customerTypeMap[customerType],
        product_name: productName,
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  updateCart: (customerType, productName, isAdd) => {
    attempt(() =>
      objTealium.link({
        event_name: `ui_interaction, ${isAdd ? 'cart_add' : 'cart_subtract'}`,
        event_action: 'click',
        link_name: `vodapay: smme: ${isAdd ? 'add product to cart' : 'subtract product from cart'}`,
        page_name: getPageName(),
        visitor_customer_type: customerTypeMap[customerType],
        product_name: productName,
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  generalInfoClick: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        tool_name: 'director tooltip',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: tooltip click',
        link_id: 'vodapay: smme: tooltip click',
        page_name: getPageName(),
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  chooseYourSolutionPageLoad: (
    businessType,
    onlineOrInStore,
    customerType,
    product_names,
    assistantId,
  ) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,product_view',
        page_name: `vodapay: smme: merchant onboarding: add devices: ${onlineOrInStore}`,
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: `add devices: ${onlineOrInStore}`,
        page_type: 'website',
        product_target_segment: businessType,
        product_name: product_names,
        smme_buying_method: onlineOrInStore,
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
      }),
    );
  },

  chooseYourSolutionShowMore: (terminalName, customerType, onlineOrInStore) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool start',
        tool_input: 'terminal show more',
        tool_name: terminalName,
        link_name: 'vodapay: smme: choose solution: terminal show more',
        page_name: `vodapay: smme: merchant onboarding: add devices: ${onlineOrInStore}`,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  chooseYourSolutionProductsQuantityChange: (
    terminalName,
    terminalPrice,
    oldQuantity,
    newQuantity,
    isManualEdit = false,
    customerType,
    onlineOrInStore,
  ) => {
    const isAdd = newQuantity >= oldQuantity;
    const productQuantity = isManualEdit ? Math.abs(newQuantity - oldQuantity) : 1;

    attempt(() =>
      objTealium.link({
        event_name: isAdd ? 'cart_add' : 'cart_remove',
        product_name: terminalName,
        visitor_customer_type: customerTypeMap[customerType],
        product_quantity: productQuantity,
        product_price: terminalPrice,
        product_category: 'POS',
        link_name: `vodapay: smme: choose solution: ${isAdd ? 'add' : 'remove'} product to cart`,
        page_name: `vodapay: smme: merchant onboarding: add devices: ${onlineOrInStore}`,
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  paymentTypesPageLoad: (customerType) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme merchant onboarding: tender type',
        ...staticOnboardingPageDetails(),
        page_type: 'website',
        visitor_customer_type: customerTypeMap[customerType],
      }),
    );
  },

  paymentTypeSelectOption: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: merchant onboarding: tender type selected',
        page_name: 'vodapay: merchant onboarding: tender type',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  paymentTypeNextClick: (customerType, tenderType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: merchant onboarding: next',
        page_name: 'vodapay: smme merchant onboarding: tender type',
        page_type: 'website',
        tender_type: tenderType,
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  showPrivateKey: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        page_name: 'vodapay: smme: self service: my profile',
        page_type: 'website',
        link_name: 'vodapay: smme: self service: show/hide gateway private key',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  yourBusinessPageLoadFormStartCombined: (
    businessType,
    customerType,
    assistantId,
    isPendingApp,
  ) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_start',
        page_name: 'vodapay: smme merchant onboarding: business information',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'business information',
        page_type: 'website',
        product_target_segment: businessType,
        form_name: 'business information',
        form_type: 'application',
        form_step_name: 'business name',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },
  yourBusinessPageFormEnd: (industry, natureOfBusiness, customerType, isPendingApp) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, form_end',
        form_name: 'merchant onboarding: about your business',
        smme_business_industry: industry,
        smme_business_nature: natureOfBusiness,
        link_name: 'vodapay: smme: business information form end',
        page_name: 'vodapay: smme merchant onboarding: business information',
        visitor_customer_type: customerTypeMap[customerType],
        journey_name: isPendingApp ? 'smme: update pending application' : '',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  businessAddressPageLoadFormStartCombined: (
    businessType,
    customerType,
    assistantId,
    isPendingApp,
  ) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_start',
        page_name: 'vodapay: smme: merchant onboarding: business address',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'business address',
        page_type: 'website',
        product_target_segment: businessType,
        form_name: 'business address',
        form_type: 'application',
        form_step_name: 'street address',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },
  businessAddressPageFormEnd: (customerType, isPendingApp) => {
    attempt(() =>
      objTealium.link({
        event_name: 'form_end',
        form_name: 'business address',
        link_name: 'vodapay: smme: business address form end',
        page_name: 'vodapay: smme merchant onboarding: business address',
        visitor_customer_type: customerTypeMap[customerType],
        journey_name: isPendingApp ? 'smme: update pending application' : '',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  toolAddressUseAutofill: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        tool_input: 'address autofill',
        link_name: 'vodapay: smme: address autofill',
        page_name: 'vodapay: smme: merchant onboarding: business address',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  yourDirectorsPageLoadFormStartCombined: (
    businessType,
    customerType,
    assistantId,
    isPendingApp,
  ) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_start',
        page_name: 'vodapay:smme: merchant onboarding: director information',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'director information',
        page_type: 'website',
        product_target_segment: businessType,
        form_name: 'business directors',
        form_type: 'application',
        form_step_name: 'director ID number',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },

  yourDirectorsAddDirector: (numOfDirectors, customerType, isPendingApp) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        tool_input: 'add director',
        smme_business_directors: numOfDirectors,
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: add director',
        page_name: 'vodapay: smme: merchant onboarding: director information',
        journey_name: isPendingApp ? 'smme: update pending application' : '',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  yourDirectorsRemoveDirector: (numOfDirectors, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        tool_input: 'remove director',
        smme_business_directors: numOfDirectors,
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: remove director',
        page_name: 'vodapay: smme: merchant onboarding: director information',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  yourDirectorCreditConsentInfo: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start, ui_interaction',
        event_action: 'click',
        tool_name: 'director tooltip',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: tooltip click',
        link_id: 'vodapay: smme: tooltip click',
        page_name: 'vodapay: smme: merchant onboarding: director information',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  yourDirectorsFormEnd: (customerType, isPendingApp, idTypes) => {
    attempt(() =>
      objTealium.view({
        event_name: 'form_end',
        form_name: 'business directors',
        link_name: 'vodapay: smme: business directors form end',
        page_name: 'vodapay: smme: merchant onboarding: director information',
        visitor_customer_type: customerTypeMap[customerType],
        journey_name: isPendingApp ? 'smme: update pending application' : '',
        ...staticOnboardingPageDetails(),
        citizenship_type: idTypes.join(','),
      }),
    );
  },
  aboutYouPageLoadFormStartCombined: (businessType, customerType, assistantId, isPendingApp) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_start',
        page_name: 'vodapay: smme: merchant onboarding: your details',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        form_name: 'about you',
        page_journey_phase: 'your details',
        product_target_segment: businessType,
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },

  aboutYouFormEnd: (businessType, customerType, idType, isPendingApp) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,form_end',
        page_name: 'vodapay: smme: merchant onboarding: your details',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        form_name: 'about you',
        page_journey_phase: 'your details',
        link_name: 'vodapay: smme: next',
        link_id: 'vodapay: smme: next',
        product_target_segment: businessType,
        visitor_id_asset_primary: idType,
        visitor_customer_type: customerTypeMap[customerType],
        journey_name: isPendingApp ? 'smme: update pending application' : '',
        citizenship_type: idType,
      }),
    );
  },

  moreDetailsPageLoadFormStartCombined: (businessType, customerType) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_start',
        page_name: 'vodapay: smme: merchant onboarding: your details 2',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        form_name: 'about you 2',
        page_journey_phase: 'your details',
        product_target_segment: businessType,
        visitor_customer_type: customerTypeMap[customerType],
      }),
    );
  },

  moreDetailsFormEnd: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,form_end',
        page_name: 'vodapay: smme: merchant onboarding: your details 2',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        form_name: 'about you 2',
        page_journey_phase: 'your details',
        link_name: 'vodapay: smme: next',
        link_id: 'vodapay: smme: next',
        visitor_customer_type: customerTypeMap[customerType],
      }),
    );
  },

  selfiePageLoad: (businessType, customerType, assistantId, isPendingApp) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: merchant onboarding: selfie options',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'selfie options',
        page_type: 'website',
        product_target_segment: businessType,
        visitor_id_asset_primary: 'ID',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },

  selfieOpenCam: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: open webcam',
        page_name: 'vodapay: smme: merchant onboarding: selfie options',
        page_journey_phase: 'selfie capture',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  selfieTakePhoto: (customerType, isPendingApp) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        tool_input: 'take photo',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: take photo',
        page_name: 'vodapay: smme: merchant onboarding: selfie options',
        page_journey_phase: 'selfie capture',
        journey_name: isPendingApp ? 'smme: update pending application' : '',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  selfieRetake: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        tool_input: 'retake photo',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: retake photo',
        page_name: 'vodapay: smme: merchant onboarding: selfie options',
        page_journey_phase: 'selfie retake',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  selfieInfo: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        tool_name: 'selfie tooltip',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: tooltip click',
        link_id: 'vodapay: smme: tooltip click',
        page_name: 'vodapay:smme: merchant onboarding: selfie options',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  selfieRefreshOrSwitch: (customerType, isSwitch) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: `vodapay: smme: ${isSwitch ? 'switch camera' : 'refresh camera'}`,
        page_name: 'vodapay:smme: merchant onboarding: selfie options',
        page_journey_phase: 'selfie retake',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  residentialAddressPageLoad: (customerType, isPendingApp) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: merchant onboarding: residential address',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        page_journey_phase: 'your details',
        visitor_customer_type: customerTypeMap[customerType],
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },

  residentialAddressPageEnd: (isPendingApp) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, form_end',
        link_page_name: 'vodapay: smme: self service:onboarding: bank details',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        link_id: 'next',
        form_name: 'merchant onboarding: bank details',
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },

  bankingPageLoadFormStartCombined: (businessType, customerType, assistantId, isPendingApp) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_start',
        page_name: 'vodapay: smme: merchant onboarding: banking details',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'banking details',
        page_type: 'website',
        product_target_segment: businessType,
        form_name: 'banking details',
        form_type: 'application',
        form_step_name: 'account holder',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },

  bankingBankSelected: (bankName, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        tool_name: 'Select bank',
        tool_input: bankName,
        tool_type: 'select',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: select bank',
        page_name: 'vodapay: smme: merchant onboarding: banking details',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  bankingAccountType: (accountType, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        tool_name: 'Account type',
        tool_input: accountType,
        tool_type: 'select',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: select account type',
        page_name: 'vodapay: smme: merchant onboarding: banking details',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  bankingClickNext: (
    customerType,
    bankAccountCategory,
    debitOrderDate,
    bankDetailsValidationResult,
    isPendingApp,
  ) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: next click',
        link_id: 'vodapay: smme: next click',
        page_name: 'vodapay: smme: merchant onboarding: banking details',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        visitor_customer_type: customerTypeMap[customerType],
        smme_bank_account_category: bankAccountCategory,
        smme_debit_order_date: debitOrderDate,
        smme_vetting_result: bankDetailsValidationResult,
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },

  uploadDocsPageLoadBankingDetailsFormEndCombined: (
    businessType,
    customerType,
    assistantId,
    isPendingApp,
  ) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_end',
        page_name: 'vodapay: smme: merchant onboarding: document upload',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'document upload',
        page_type: 'website',

        product_target_segment: businessType,
        form_name: 'banking details',

        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },

  uploadDocsUpload: (documentType, customerType, isPendingApp) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        tool_name: documentType,
        tool_type: 'document upload',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: document upload',
        page_name: 'vodapay: smme: merchant onboarding: document upload',
        journey_name: isPendingApp ? 'smme: update pending application' : '',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  uploadError: (errorMessage) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_error',
        event_error_name: 'Document upload failed',
        event_error_code: errorMessage,
        event_error_type: 'user error',
        link_name: 'vodapay: smme: document upload error',
        page_name: 'vodapay: smme: merchant onboarding: document upload',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  dxlErrorUploadMiniApp: (errorMessage, page) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_error',
        event_error_name: 'DXL upload error',
        event_error_code: errorMessage,
        event_error_type: 'mobile app error',
        link_name: 'vodapay: smme: dxl upload error',
        page_name: `vodapay: smme: merchant onboarding: ${page}`,
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  dxlErrorDownloadMiniApp: (errorMessage, page) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_error',
        event_error_name: 'DXL download error',
        event_error_code: errorMessage,
        event_error_type: 'mobile app error',
        link_name: 'vodapay: smme: dxl download error',
        page_name: `vodapay: smme: merchant onboarding: ${page}`,
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  uploadDocsSuccessfulPageView: (businessType, customerType, isPendingApp) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: merchant onboarding: document upload',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        product_target_segment: businessType,
        page_journey_phase: 'document upload successful',
        visitor_customer_type: customerTypeMap[customerType],
        journey_name: isPendingApp ? 'smme: update pending application' : '',
      }),
    );
  },

  docsOpenCameraButton: (customerType, documentType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        tool_name: documentType,
        tool_type: 'open camera',
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: document upload',
        page_name: 'smme: merchant onboarding: document upload',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  docsOpenCameraModal: (customerType) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay:smme: merchant onboarding: document camera capture',
        ...staticOnboardingPageDetails(),
        page_type: 'website',
        visitor_customer_type: customerTypeMap[customerType],
      }),
    );
  },

  docsCaptureImage: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        tool_type: 'open camera',
        visitor_customer_type: customerTypeMap[customerType],
        page_type: 'website',
        link_name: 'vodapay: smme: take photo',
        link_id: 'vodapay: smme: take photo',
        page_name: 'vodapay:smme: merchant onboarding: document camera capture',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  docsRefreshCamera: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        tool_type: 'open camera',
        visitor_customer_type: customerTypeMap[customerType],
        page_type: 'website',
        link_name: 'vodapay: smme: refresh camera',
        link_id: 'vodapay: smme: refresh camera',
        page_name: 'vodapay:smme: merchant onboarding: document camera capture',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  docsSwitchCamera: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        tool_type: 'open camera',
        visitor_customer_type: customerTypeMap[customerType],
        page_type: 'website',
        link_name: 'vodapay: smme: switch camera',
        link_id: 'vodapay: smme: switch camera',
        page_name: 'vodapay:smme: merchant onboarding: document camera capture',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  confirmPageLoadCheckoutStartCombined: (
    businessType,
    productNameList,
    quantityList,
    priceList,
    customerType,
    assistantId,
    tenderTypeSelected,
  ) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,checkout_start',
        page_name: 'vodapay: smme: merchant onboarding: order summary',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'order summary',
        page_type: 'website',
        product_target_segment: businessType,
        cart_product_category: 'Merchant Payment Services',
        product_name: productNameList,
        product_quantity: quantityList,
        product_price: priceList,
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
        tender_type: tenderTypeSelected,
      }),
    );
  },

  confirmClickPrint: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: print application',
        page_name: 'vodapay: smme: merchant onboarding: order summary',
        link_type: 'o',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  confirmClickDownload: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: download application',
        page_name: 'vodapay: smme: merchant onboarding: order summary',
        link_type: 'b',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  thankYouClickPrint: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: print complete application',
        page_name: 'vodapay:smme: merchant onboarding: application complete',
        link_type: 'o',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  thankYouClickDownload: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: download complete application',
        page_name: 'vodapay:smme: merchant onboarding: application complete',
        link_type: 'b',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  confirmTerminalQuantityChange: (
    terminalName,
    terminalPrice,
    oldQuantity,
    newQuantity,
    isManualEdit,
    customerType,
  ) => {
    const isAdd = newQuantity >= oldQuantity;
    const productQuantity = isManualEdit ? Math.abs(newQuantity - oldQuantity) : 1;

    attempt(() =>
      objTealium.link({
        event_name: isAdd ? 'cart_add' : 'cart_remove',
        product_name: terminalName,
        visitor_customer_type: customerTypeMap[customerType],
        product_quantity: productQuantity,
        product_price: terminalPrice,
        product_category: 'POS',
        link_name: `vodapay: smme: ${isAdd ? 'add' : 'remove'} product to cart`,
        page_name: 'vodapay: smme: merchant onboarding: order summary',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  confirmClickEditBusinessInfo: (href, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: edit business information',
        page_name: 'vodapay: smme: merchant onboarding: order summary',
        link_type: 'o',
        link_url: href,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  confirmClickEditPersonalInfo: (href, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: edit personal information',
        page_name: 'vodapay: smme: merchant onboarding: order summary',
        link_type: 'o',
        link_url: href,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  confirmClickEditAddress: (href, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: edit address',
        page_name: 'vodapay: smme: merchant onboarding: order summary',
        link_type: 'o',
        link_url: href,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  confirmClickAddAddress: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,journey_start',
        event_action: 'click',
        link_name: 'vodapay: smme: add delivery address',
        link_id: 'vodapay: smme: add delivery address',
        page_name: 'vodapay: smme: merchant onboarding: order summary',
        link_type: 'o',
        visitor_customer_type: customerTypeMap[customerType],
        journey_name: 'add_delivery_address',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  confirmAddAddressJourneyStepFormStart: (stepName, customerType, businessType) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_start',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        product_target_segment: businessType,
        visitor_customer_type: customerTypeMap[customerType],
        page_name: `vodapay: smme: merchant onboarding: ${stepName}`,
        page_journey_phase: stepName,
        form_name: stepName,
      }),
    );
  },
  toolAddressUseAutofillConfirmDeliveryAddress: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'tool_start',
        tool_input: 'address autofill',
        link_name: 'vodapay: smme: address autofill',
        page_name: 'vodapay: smme: merchant onboarding: delivery address',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  confirmAddAddressJourneyStepFormEnd: (
    stepName,
    customerType,
    endJourney = false,
    additionalFields,
  ) => {
    const newFields = additionalFields || {};
    let properties = {
      ...newFields,
      event_name: 'form_end,ui_interaction',
      event_action: 'click',
      form_name: stepName,
      page_name: `vodapay: smme: merchant onboarding: ${stepName}`,
      link_name: `vodapay: smme: ${stepName} next`,
      link_type: 'o',
      visitor_customer_type: customerTypeMap[customerType],
      ...staticOnboardingPageDetails(),
    };

    if (endJourney) {
      properties = {
        ...properties,
        event_name: `${properties.event_name},journey_end`,
        journey_name: 'add delivery address',
        journey_type: 'transaction',
      };
    }

    attempt(() => objTealium.link(properties));
  },

  confirmAddAddressExitButtonClick: (stepName, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_type: 'o',
        link_name: 'vodapay: smme: add address close',
        page_name: `vodapay: smme: merchant onboarding: ${stepName}`,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  confirmRemoveAddress: (numOfAddresses, customerType) => {
    attempt(() =>
      objTealium.link({
        smme_business_addresses: numOfAddresses,
        visitor_customer_type: customerTypeMap[customerType],
        link_name: 'vodapay: smme: remove address',
        page_name: 'vodapay: smme: merchant onboarding: order summary',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  thankYouPageLoad: (
    businessType,
    productNameList,
    quantityList,
    priceList,
    isOtpUsed,
    orderedRentalDevice,
    orderedOnceOffFeeDevice,
    onlineOrInStore,
    customerType,
    orderTotal,
    turnover,
    assistantId,
    referenceNumber,
    phoneNumber,
    email,
    tenderType,
  ) => {
    attempt(() => {
      let cartTypes = [];
      orderedRentalDevice && cartTypes.push('monthly rental');
      orderedOnceOffFeeDevice && cartTypes.push('once-off payment');

      objTealium.view({
        event_name:
          'page_view,checkout_complete,journey_end,smme_application_complete,transaction_complete',
        page_name: 'vodapay: smme: merchant onboarding: application complete',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'application complete',
        page_type: 'website',
        product_target_segment: businessType,
        cart_id: referenceNumber,
        cart_product_category: 'Merchant Payment Services',
        product_name: productNameList,
        product_quantity: quantityList,
        product_price: priceList,
        product_category: 'POS',
        transaction_total: orderTotal,
        journey_name: isOtpUsed ? 'continue application' : 'new application',
        journey_type: 'transaction',
        transaction_id: referenceNumber,
        transaction_payment_type: cartTypes.join(','),
        smme_buying_method: onlineOrInStore,
        visitor_customer_type: customerTypeMap[customerType],
        smme_monthly_income: turnover,
        visitor_id_company: assistantId,
        visitor_id_asset_active: phoneNumber,
        visitor_id_marketing_email: email,
        tender_type: tenderType,
      });
    });
  },
  thankYouPaymentGatewayJourneyEnd: (customerType, assistantId) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,journey_end',
        journey_name: 'reserve funds: payment gateway',
        link_name: 'vodapay: smme: reserve funds thank you',
        page_name: 'vodapay: smme: merchant onboarding: application complete',
        link_type: 'o',
        link_url: 'payment gateway',
        journey_type: 'transaction',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  // Onboarding Payment
  reserveFundsPageLoad: (businessType, customerType, assistantId) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: merchant onboarding: reserve funds confirmation',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'reserve funds confirmation',
        page_type: 'website',
        product_target_segment: businessType,
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
      }),
    );
  },
  reserveFundsConfirmButtonClick: (buttonUrl, customerType, assistantId) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,journey_start',
        event_action: 'click',
        link_name: 'vodapay: smme: reserve funds button',
        page_name: 'vodapay: smme: merchant onboarding: reserve funds confirmation',
        link_type: 'o',
        link_url: buttonUrl,
        page_journey_phase: 'reserve funds confirmation',
        journey_name: 'reserve funds: payment gateway',
        journey_type: 'transaction',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  reserveFundsFailedPageLoad: (businessType, customerType, assistantId) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,event_error',
        page_name: 'vodapay: smme: merchant onboarding: payment failed',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'payment reservation failed',
        page_type: 'website',
        product_target_segment: businessType,
        event_error_name: 'payment failed',
        event_error_code: 'payment gateway returned error',
        event_error_type: 'user error',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
      }),
    );
  },
  reserveFundsRetryButtonClick: (buttonUrl, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: retry reserve funds',
        page_name: 'vodapay: smme: merchant onboarding: payment failed',
        link_type: 'o',
        link_url: buttonUrl,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  // FICA Polling Screens for Agent Journey
  ficaInProgressPageLoad: ({
    businessType,
    productNameList,
    quantityList,
    priceList,
    isOtpUsed,
    transactionId,
    customerType,
    customerId,
    transactionPaymentType,
    transactionTotal,
  }) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,checkout_complete,journey_end',
        page_name: 'vodapay:smme: merchant onboarding: fica processing',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'fica processing',
        page_type: 'website',
        product_target_segment: businessType,
        cart_id: transactionId,
        cart_product_category: 'Merchant Payment Services',
        product_name: productNameList,
        product_quantity: quantityList,
        product_price: priceList,
        journey_name: isOtpUsed ? 'continue application' : 'new application',
        journey_type: 'transaction',
        transaction_id: transactionId,
        transaction_total: transactionTotal,
        transaction_payment_type: transactionPaymentType,
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: customerId,
      }),
    );
  },
  ficaInProgressJourneyStart: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'journey_start',
        journey_name: 'fica processing',
        journey_type: 'transaction',
      }),
    );
  },
  ficaInProgressJourneyEnd: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'journey_end',
        journey_name: 'fica processing',
        journey_type: 'transaction',
      }),
    );
  },
  ficaClickDone: (link, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'done',
        link_type: 'o',
        link_url: link,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  ficaFailurePageLoad: ({
    businessType,
    productNameList,
    quantityList,
    priceList,
    transactionId,
    customerType,
    customerId,
    transactionPaymentType,
    transactionTotal,
  }) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,smme_application_complete',
        page_name: 'vodapay:smme: merchant onboarding: fica unsuccessful',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'fica unsuccessful',
        page_type: 'website',
        product_target_segment: businessType,
        cart_id: transactionId,
        cart_product_category: 'Merchant Payment Services',
        product_name: productNameList,
        product_quantity: quantityList,
        product_price: priceList,
        transaction_id: transactionId,
        transaction_total: transactionTotal,
        transaction_payment_type: transactionPaymentType,
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: customerId,
      }),
    );
  },
  ficaPendingPageLoad: ({
    businessType,
    productNameList,
    quantityList,
    priceList,
    transactionId,
    customerType,
    customerId,
    transactionPaymentType,
    transactionTotal,
  }) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,smme_application_complete',
        page_name: 'vodapay:smme: merchant onboarding: fica pending',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'fica pending',
        page_type: 'website',
        product_target_segment: businessType,
        cart_id: transactionId,
        cart_product_category: 'Merchant Payment Services',
        product_name: productNameList,
        product_quantity: quantityList,
        product_price: priceList,
        transaction_id: transactionId,
        transaction_total: transactionTotal,
        transaction_payment_type: transactionPaymentType,
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: customerId,
      }),
    );
  },
  ficaSuccessfulPageLoad: ({
    businessType,
    productNameList,
    quantityList,
    priceList,
    transactionId,
    customerType,
    customerId,
    transactionPaymentType,
    transactionTotal,
    monthlyCardTurnover,
  }) => {
    objTealium.view({
      event_name: 'page_view,smme_application_complete,transaction_complete',
      page_name: 'vodapay:smme: merchant onboarding: fica successful',
      page_url: window.location.href,
      page_section: 'onboarding',
      page_channel: 'vodapay: merchant onboarding',
      page_subdomain: 'merchant onboarding',
      page_journey_phase: 'fica successful',
      page_type: 'website',
      product_target_segment: businessType,
      cart_id: transactionId,
      cart_product_category: 'Merchant Payment Services',
      product_name: productNameList,
      product_quantity: quantityList,
      product_price: priceList,
      transaction_total: transactionTotal,
      transaction_id: transactionId,
      transaction_payment_type: transactionPaymentType,
      visitor_customer_type: customerTypeMap[customerType],
      visitor_id_company: customerId,
      smme_monthly_income: monthlyCardTurnover,
    });
  },
  //Continue Application links
  continueApplicationPageLoadFormStartCombined: (customerType, assistantId) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,form_start',
        page_name: 'vodapay: smme: merchant onboarding: continue application',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',

        // form_start, visitor_login_start
        form_name: 'continue application',
        form_type: 'continue application',
        form_step_name: 'email',

        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,
      }),
    );
  },
  continueApplicationReferenceFormEndContinueClickCombined: (href, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,form_end',
        event_action: 'click',
        link_name: 'vodapay: smme: continue',
        page_name: 'vodapay: smme: merchant onboarding: continue application',
        link_type: 'o',
        link_url: href,
        visitor_customer_type: customerTypeMap[customerType],
        form_name: 'continue application',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  continueApplicationReferenceEventError: (message, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'event_error',
        event_error_name: message,
        event_error_code: message,
        event_error_type: 'user error',
        link_name: 'vodapay: smme: continue error',
        page_name: 'vodapay: smme: merchant onboarding: continue application',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  continueApplicationOTPPageLoadFormStartCombined: (customerType, assistantId) => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view,visitor_login_multi_factor,form_start',
        page_name: 'vodapay: smme: merchant onboarding: enter OTP',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_journey_phase: 'otp',
        page_type: 'website',
        visitor_customer_type: customerTypeMap[customerType],
        visitor_id_company: assistantId,

        // form_start
        form_name: 'OTP',
        form_type: 'OTP',
      }),
    );
  },
  continueApplicationOTPClickRequestNew: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,visitor_login_complete',
        event_action: 'click',
        link_name: 'vodapay: smme: request new OTP',
        page_name: 'vodapay: smme: merchant onboarding: enter OTP',
        link_type: 'o',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  continueApplicationOTPClickContinue: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,form_end',
        event_action: 'click',
        link_name: 'vodapay: smme: OTP continue',
        link_id: 'vodapay: smme: OTP continue',
        page_name: 'vodapay: smme: merchant onboarding: enter OTP',
        link_type: 'o',
        form_name: 'OTP',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  continueApplicationOTPEventError: (message, customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'event_error',
        event_error_name: message,
        event_error_code: message,
        event_error_type: 'user error',
        link_name: 'vodapay: smme: OTP error',
        page_name: 'vodapay: smme: merchant onboarding: enter OTP',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  ///////// ----- VB POS DIST ----- //////

  startPosDist: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view, form_start',
        page_name: 'vodapay: smme: merchant onboarding: pos: get started',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',

        // form_start, visitor_login_start
        form_name: 'POS get started',
        form_type: 'login',
        form_step_name: 'email address',

        visitor_customer_type: customerTypeMap['pos'],
      }),
    );
  },

  posDistReferenceFormEndContinueClickCombined: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,form_end',
        event_action: 'click',
        link_name: 'vodapay: smme: continue',
        page_name: 'vodapay: smme: merchant onboarding: pos: get started',
        link_type: 'o',
        link_url: window.location.href,
        visitor_customer_type: customerTypeMap['pos'],
        form_name: 'POS get started',
      }),
    );
  },

  enterReferenceLoadPosDist: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view, visitor_login_multi_factor, form_start',
        page_name: 'vodapay: smme: merchant onboarding:enter OTP',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',

        // form_start, visitor_login_start
        form_name: 'OTP',
        form_type: 'OTP',

        visitor_customer_type: customerTypeMap['pos'],
      }),
    );
  },

  clickOTPPosDist: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: OTP continue',
        link_id: 'vodapay: smme: OTP continue',
        page_name: 'vodapay: smme: merchant onboarding: enter OTP',
        link_type: 'o',
        visitor_customer_type: customerTypeMap['pos'],
      }),
    );
  },

  successfulOTPPosDist: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'visitor_login_complete, journey_start, form_end',
        page_name: 'vodapay: smme: merchant onboarding:type of business',
        page_url: window.location.href,
        form_name: 'OTP',
        journey_name: 'new application',
        journey_type: 'POS Distribution',
        page_journey_phase: 'otp',
        visitor_customer_type: customerTypeMap['pos'],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  ///////// ----- General ----- //////

  //FAQ links
  faqOpen: (question) => {
    attempt(() => {
      objTealium.link({
        link_type: 'o',
        link_name: `${window.utag.data.page_name}: ${question}`,
        ...staticSelfServicePageDetails(),
      });
    });
  },

  // Help
  helpOnboardingOpenButtonClick: (customerType, url, lowestLevelPath) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, support_issue_raised',
        event_action: 'click',
        link_name: 'vodapay: smme: Help',
        link_type: 'o',
        visitor_customer_type: customerTypeMap[customerType],
        page_url: url,
        page_name: pageNameMap[lowestLevelPath],
        page_type: 'website',
        link_id: 'vodapay: smme: help',
        journey_name: 'smme: update pending application',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  helpOnboardingSupportNumberClick: (url, customerType, lowestLevelPath) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,support_issue_raised',
        event_action: 'click',
        link_name: 'vodapay: smme: call support number',
        link_type: 'e',
        link_url: url,
        page_name: pageNameMap[lowestLevelPath],
        page_url: url,
        page_type: 'website',
        link_id: 'vodapay: smme: help: call support',
        journey_name: 'smme: update pending application',
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  helpOnboardingEmailClick: (url, customerType, lowestLevelPath) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,support_issue_raised',
        event_action: 'click',
        link_name: 'vodapay: smme: Email support',
        link_type: 'e',
        link_url: url,
        visitor_customer_type: customerTypeMap[customerType],
        page_name: pageNameMap[lowestLevelPath],
        page_url: url,
        page_type: 'website',
        link_id: 'vodapay: smme: help: email support',
        journey_name: 'smme: update pending applications',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  // Help events for self-service
  helpSelfServiceOpenButtonClick: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: Help',
        link_type: 'o',
        page_url: window.location.href,
        page_name: `vodapay: smme: self service: ${getPageName()}`,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  helpSelfServiceSupportNumberClick: (url) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,support_issue_raised',
        event_action: 'click',
        link_name: 'vodapay: smme: Call support number',
        link_type: 'e',
        link_url: url,
        page_name: `vodapay: smme: self service: ${getPageName()}`,
        page_url: url,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  helpSelfServiceEmailClick: (url) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction,support_issue_raised',
        event_action: 'click',
        link_name: 'vodapay: smme: Email support',
        link_type: 'e',
        link_url: url,
        page_name: `vodapay: smme: self service: ${getPageName()}`,
        page_url: url,
        ...staticSelfServicePageDetails(),
      }),
    );
  },
  // Handled Errors for self-service
  onHandledErrorFormSelfService: (message, code) => {
    const pageName = getPageName();
    emitFormError(
      message,
      `vodapay: smme: self service: ${getPageName()}`,
      `vodapay: smme portal: ${pageName} error`,
      code || 'N/A',
      'user error',
      journeyMap.ss,
    );
  },
  onHandledErrorPageLoadSelfService: (message, code) => {
    const pageName = getPageName();
    emitPageError(
      message,
      `vodapay: smme: self service: ${getPageName()}`,
      `vodapay: smme portal: ${pageName} error`,
      code || 'N/A',
      'user error',
      journeyMap.ss,
    );
  },
  onHandledErrorEventSelfService: (message, code) => {
    const pageName = getPageName();
    emitEventError(
      message,
      `vodapay: smme: self service: ${getPageName()}`,
      `vodapay: smme portal: ${pageName} error`,
      code || 'N/A',
      'user error',
      journeyMap.ss,
    );
  },
  // Technical (unhandled) Errors for self-Service
  onTechnicalErrorPageLoadSelfServiceIssue: (message) => {
    emitPageError(
      message,
      `vodapay: smme: self service: ${getPageName()}`,
      `vodapay: smme portal: technical error`,
      'N/A',
      'system error',
      journeyMap.ss,
    );
  },
  onTechnicalErrorUserEventTriggeredSelfServiceIssue: (message) => {
    emitEventError(
      message,
      `vodapay: smme: self service: ${getPageName()}`,
      `vodapay: smme portal: technical error`,
      'N/A',
      'system error',
      journeyMap.ss,
    );
  },
  // Technical Error For Onboarding
  onTechnicalErrorPageLoadIssue: (message, isTop = false) => {
    attempt(() =>
      objTealium.link({
        event_name: 'page_error',
        link_name: 'vodapay: smme: page error',
        page_error_name: isTop ? 'technical issue' : message,
        page_error_code: 'N/A',
        page_error_type: 'system error',
        page_name: pageNameMap[getLowestLevelPath()] || 'unknown',
        visitor_customer_type: customerTypeMap[onboardingCustomerType],
        ...(isTop ? staticToPVariables() : staticOnboardingPageDetails()),
      }),
    );
  },
  onTechnicalErrorUserEventTriggeredIssue: (message) => {
    attempt(() =>
      objTealium.link({
        event_name: 'event_error',
        link_name: 'vodapay: smme: event error',
        event_error_name: message,
        event_error_code: 'N/A',
        event_error_type: 'system error',
        page_name: pageNameMap[getLowestLevelPath()] || 'unknown',
        visitor_customer_type: customerTypeMap[onboardingCustomerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  onHandledErrorEventOnboarding: (message, pageName) => {
    emitEventError(
      message,
      `vodapay: smme: merchant onboarding: ${pageName}`,
      `vodapay: smme: merchant onboarding: error ${pageName}`,
      message,
      'user error',
      journeyMap.ob,
    );
  },
  onOnboardingbuttonClick: (linkAction, customerType, pageName) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: `vodapay: smme: merchant onboarding: ${linkAction}`,
        page_name: `vodapay: smme: merchant onboarding: ${pageName}`,
        visitor_customer_type: customerTypeMap[customerType],
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  // Toast Error
  onToastError: (message, errorCode, isUserError = false) => {
    attempt(() =>
      objTealium.link({
        event_name: 'event_error',
        event_error_name: message,
        event_error_code: errorCode,
        event_error_type: isUserError ? 'user error' : 'system error',
        page_name: getPageName(),
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  missingWebcamModalView: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view, page_error',
        page_name: 'vodapay:smme: merchant onboarding: oops enable webcam',
        page_type: 'website',
        page_error_name: 'We need your webcam active for us to proceed with your application',
        page_error_code: 'n/a',
        page_error_type: 'user error',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  cameraEnabledButton: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        page_type: 'website',
        link_name: 'enable webcam',
        link_id: 'enable webcam',
        page_name: 'vodapay:smme: merchant onboarding: oops enable webcam',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  beBackLater: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        page_type: 'website',
        link_name: "I'll be back later",
        link_id: "I'll be back later",
        page_name: 'vodapay:smme: merchant onboarding: oops enable webcam',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  productsAndServices: () => {
    attempt(() =>
      objTealium.view({
        event_name: 'page_view',
        page_type: 'website',
        page_name: 'vodapay:smme: self service: products & services',
        ...staticSelfServicePageDetails(),
      }),
    );
  },

  //Camera enabled button click mini-app
  cameraEnabledButtonClickMiniApp: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: my camera enabled',
        link_type: 'o',
        visitor_customer_type: customerTypeMap[customerType],
        page_name: 'vodapay: smme: merchant onboarding: camera permission',
        ...staticOnboardingPageDetails(),
      }),
    );
  },
  //Camera enable now button click mini-app
  cameraEnableNowButtonClickMiniApp: (customerType) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        event_action: 'click',
        link_name: 'vodapay: smme: enable camera now',
        link_type: 'o',
        visitor_customer_type: customerTypeMap[customerType],
        page_name: 'vodapay: smme: merchant onboarding: camera permission',
        ...staticOnboardingPageDetails(),
      }),
    );
  },

  errorSummaryView: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay:smme: smme: update pending application',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        journey_name: 'smme: update pending application',
      });
    });
  },

  errorSummaryEnd: () => {
    attempt(() => {
      objTealium.link({
        event_name: 'ui_interaction, journey_start',
        link_page_name: 'vodapay:smme: smme: update pending application',
        page_url: window.location.href,
        page_section: 'onboarding',
        page_channel: 'vodapay: merchant onboarding',
        page_subdomain: 'merchant onboarding',
        page_type: 'website',
        link_name: 'smme: update application',
        journey_name: 'smme: update pending application',
      });
    });
  },

  declinedApplicationView: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view, journey_end',
        page_name: 'vodapay: smme: self service:onboarding: application declined',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        journey_name: 'smme: update pending application',
      });
    });
  },

  declinedApplicationExit: () => {
    attempt(() => {
      objTealium.link({
        event_name: 'page_view, journey_end',
        page_name: 'vodapay: smme: self service:onboarding: application declined',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        link_id: 'update pending application: exit',
        journey_name: 'smme: update pending application',
      });
    });
  },

  declinedApplicationEmail: () => {
    attempt(() => {
      objTealium.link({
        event_name: 'ui_interaction',
        page_name: 'vodapay: smme: self service:onboarding: application declined',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        link_id: 'update pending application: email support',
        journey_name: 'smme: update pending application',
      });
    });
  },

  declinedApplicationContactNumber: () => {
    attempt(() => {
      objTealium.link({
        event_name: 'ui_interaction',
        page_name: 'vodapay: smme: self service:onboarding: application declined',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        link_id: 'update pending application: call support',
        journey_name: 'smme: update pending application',
      });
    });
  },

  completedApplicationView: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view, journey_end',
        page_name: 'vodapay: smme: self service:onboarding: onboarding complete',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        journey_name: 'smme: update pending application',
      });
    });
  },

  completedApplicationExit: () => {
    attempt(() => {
      objTealium.link({
        event_name: 'ui_interaction',
        page_name: 'vodapay: smme: self service:onboarding: onboarding complete',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        link_id: 'done',
        journey_name: 'smme: update pending application',
      });
    });
  },

  myProfileExpandsOrCollapsesTab: (isCollapse, tabName) => {
    attempt(() =>
      objTealium.link({
        page_name: 'vodapay: smme: self service: my profile',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',
        visitor_login_status: 'logged in',

        page_url: window.location.href,
        link_name: `vodapay: smme: self service: my profile: ${
          isCollapse ? 'collapses' : 'expand'
        }: ${tabName}`,
      }),
    );
  },

  changeBankingDetailsButton: () => {
    attempt(() =>
      objTealium.link({
        page_name: 'vodapay: smme: self service: my profile: banking details',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',
        visitor_login_status: 'logged in',
        link_name: 'vodapay: smme: self service: my profile: banking details: change',
      }),
    );
  },

  landOnPersonalDetails: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view, form_start',

        page_name: 'vodapay: smme: self service: my profile: banking details: change',
        page_section: ' self service',
        page_channel: 'mobile app',
        page_type: 'website',

        visitor_login_status: 'logged in',
        form_name: 'banking details',
        form_type: 'personal details',
      });
    });
  },

  landOnPersonalDetailsForm: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view, journey_end',
        page_name: 'vodapay: smme: self service:onboarding: onboarding complete',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        journey_name: 'smme: update pending application',
      });
    });
  },
  personalDetailsFormStep: (formName) => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view, journey_end',
        page_name: 'vodapay: smme: self service:onboarding: onboarding complete',
        page_url: window.location.href,
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        journey_name: 'smme: update pending application',
        form_step_name: `${formName}`,
      });
    });
  },

  uploadProofOfBanking: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',

        page_name: 'vodapay: smme: self service: my profile: banking details: change',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',
        visitor_login_status: 'logged in',
        link_name:
          'vodapay: smme: self service: my profile: banking details: change: documents uploaded',
      }),
    );
  },
  bankingDetailsOtpModal: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: my profile: banking details: otp',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',
        visitor_login_status: 'logged in',
      });
    });
  },
  receivedBankingDetailsUpdateModal: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: my profile: banking details: confirmation',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',
        visitor_login_status: 'logged in',
      });
    });
  },

  otpLimitExceeded: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: my profile: banking details: otp: limit exceeded',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',
        visitor_login_status: 'logged in',
      });
    });
  },

  receivedTerminalUpdateModal: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view',

        page_name: 'vodapay smme: self service: terminal: save: confirmation',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',
        visitor_login_status: ' logged in',
      });
    });
  },

  inProgressTerminalUpdateModal: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: terminal: save: in progress',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: ' website',
        visitor_login_status: 'logged in',
      });
    });
  },
  updateBankingDetailsAttemptLeft: (attemptLeft, backendError) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, form_error',

        page_name: 'vodapay: smme: self service: my profile: banking details: otp',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: ' website',

        visitor_login_status: 'logged in',
        form_error_name: `incorrect otp: ${attemptLeft} attempts left`,
        form_error_code: `${backendError}`,
        form_error_type: 'user error',
      }),
    );
  },
  updateBankingDetailsContinueButton: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',

        page_name: 'vodapay: smme: self service: my profile: banking details: otp',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',

        visitor_login_status: 'logged in',

        link_name: 'vodapay: smme: self service: my profile: banking details: otp: continue',
      }),
    );
  },
  terminalTab: (tabName) => {
    attempt(() =>
      objTealium.link({
        page_name: ' vodapay: smme: self service: terminal',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',
        visitor_login_status: 'logged in',
        link_name: `vodapay:smme: self service: terminal: ${tabName}: change`,
      }),
    );
  },

  terminalExpandsOrCollapsesTab: (isCollapse, tabName) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',

        page_name: 'vodapay: smme: self service: terminal',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',

        visitor_login_status: 'logged in',

        link_name: `vodapay: smme: self service: terminal: ${
          isCollapse ? 'collapses' : 'expand'
        }: ${tabName}`,
      }),
    );
  },
  userClicksSaveOnTerminal: (tabName) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',
        page_name: 'vodapay: smme: self service: terminal',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',

        visitor_login_status: 'logged in',

        link_name: `vodapay: 'smme: self service: terminal: ${tabName}: save`,
      }),
    );
  },
  receivedTerminalUpdateModalExit: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',

        page_name: 'vodapay: smme: self service: terminal: save: confirmation',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',
        visitor_login_status: 'logged in',
        link_name: 'vodapay: smme: self service: terminal: save: confirmation: exit',
      }),
    );
  },

  inProgressTerminalUpdateModalOkay: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',

        page_name: 'vodapay: smme: self service: terminal: save: in progress',
        page_section: 'self service',
        page_channel: 'mobile app',
        page_type: 'website',
        visitor_login_status: 'logged in',
        link_name: 'vodapay: smme: self service: terminal: save: in progress: okay',
      }),
    );
  },

  //Login

  //login tagging

  landOnLogin: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: buy pos: 3rd party: login',
        page_section: 'buy pos',
        page_channel: 'vodapay: buy pos',
        page_subdomain: 'buy pos',
        page_type: 'website',
        form_name: 'buy pos: 3rd party: login',
        form_type: 'login',
      });
    });
  },
  spendMorethan45sOnLogin: (incompleteFields, formCompletionRate, customerType) => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view, form_start',
        page_name: 'vodapay: buy pos: 3rd party: login',
        page_section: 'buy pos',
        page_channel: 'vodapay: buy pos',
        page_subdomain: 'buy pos',
        page_type: 'website',
        form_name: 'buy pos: 3rd party: login',
        form_type: 'login',
        form_completion_rate: `${formCompletionRate}`,
        form_field_incomplete: `${incompleteFields}`,
        visitor_customer_type: customerTypeMap[customerType],
      });
    });
  },

  userClicksLogin: (itemClicked) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',

        page_name: 'vodapay: buy pos: 3rd party: login',
        page_section: 'buy pos',
        page_channel: 'vodapay: buy pos',
        page_subdomain: 'buy pos',
        page_type: 'website',
        link_name: `vodapay: buy pos: 3rd party: login: ${itemClicked} `,
      }),
    );
  },

  LoginFailed: (formErrorName, formErrorCode) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',

        page_name: 'vodapay: buy pos: 3rd party: login',
        page_section: 'buy pos',
        page_channel: 'vodapay: buy pos',
        page_subdomain: 'buy pos',
        page_type: 'website',
        link_name: `vodapay: buy pos: 3rd party: login: login button`,
        form_error_name: `${formErrorName}`,
        form_error_code: `${formErrorCode}`,
        form_error_type: `${formErrorCode > 500 ? 'system error' : 'user error'}`,
      }),
    );
  },

  LoginSuccessfully: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',

        page_name: 'vodapay: buy pos: 3rd party: login',
        page_section: 'buy pos',
        page_channel: 'vodapay: buy pos',
        page_subdomain: 'buy pos',
        page_type: 'website',
        link_name: `vodapay: buy pos: 3rd party: login: login button`,
        form_name: 'buy pos: 3rd party: login',
        form_type: 'login',
      }),
    );
  },

  //CPA Login

  landOnCPALogin: () => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view',
        page_name: 'vodapay: smme: self service: onboarding: update pending application: login',
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
      });
    });
  },

  spendMorethan45sOnCPALogin: (incompleteFields, formCompletionRate, customerType) => {
    attempt(() => {
      objTealium.view({
        event_name: 'page_view, form_start',

        page_name: 'vodapay: smme: self service: onboarding: update pending application: login',
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        form_completion_rate: `${incompleteFields}`,
        form_field_incomplete: `${formCompletionRate}`,
        form_name: 'update pending applications: login',
        form_type: 'login',
        visitor_customer_type: customerTypeMap[customerType],
      });
    });
  },
  LoginCPAFailed: (formErrorName, formErrorCode) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',

        page_name: 'vodapay: smme: self service: onboarding: update pending application: login',
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',

        link_name:
          'vodapay: smme: self service: onboarding: update pending application: login: continue',
        form_error_name: `${formErrorName}`,
        form_error_code: `${formErrorCode}`,
        form_error_type: `${formErrorCode > 500 ? 'system error' : 'user error'}`,
      }),
    );
  },
  CPALoginSuccessfully: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, form_complete',

        page_name: 'vodapay: smme: self service: onboarding: update pending application: login',
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        link_name:
          'vodapay: smme: self service: onboarding: update pending application: login: continue',
        form_name: 'update pending applications: login',
        form_type: 'login',
      }),
    );
  },

  userClicksCPALogin: (itemClicked) => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction',

        page_name: 'onboarding: update pending application: login',
        page_section: 'self service',
        page_channel: 'vodapay:  self service',
        page_subdomain: 'vodapay:  self service',
        page_type: 'website',
        link_name: `vodapay:smme: self service: onboarding: update pending application: login: ${itemClicked} `,
      }),
    );
  },

  failedCPALogin: () => {
    attempt(() =>
      objTealium.link({
        event_name: 'ui_interaction, form_complete',
        page_name: 'vodapay: smme: self service: onboarding: update pending application: login',
        page_section: 'self service',
        page_channel: 'vodapay: self service',
        page_subdomain: 'vodapay: self service',
        page_type: 'website',
        link_name:
          'vodapay: smme: self service: onboarding: update pending application: login: continue',

        form_name: 'update pending applications: login',
        form_type: 'login',
      }),
    );
  },

  notYetImplementedTagging: (details) =>
    console.error(`TODO: add tagging before production release: ${details}`),
};

export default TealiumEvents;
